import { render, staticRenderFns } from "./AddTutorTask.vue?vue&type=template&id=13561f59&scoped=true"
import script from "./AddTutorTask.vue?vue&type=script&lang=js"
export * from "./AddTutorTask.vue?vue&type=script&lang=js"
import style0 from "./AddTutorTask.vue?vue&type=style&index=0&id=13561f59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13561f59",
  null
  
)

export default component.exports